import {RepositoryFactory} from '@/repositories/RepositoryFactory';
import {ROUTE_CAFE24_ERROR} from '@/router/routeNames';

const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

export const CAFE24_COMPLETE_INIT = 'CAFE24_COMPLETE_INIT';
export const CAFE24_SET_MALL = 'CAFE24_SET_MALL';

const COMPLETE_INIT = 'COMPLETE_INIT';
const SET_MALL = 'SET_MALL';

const getInitState = () => ({
    isInit: false,  // code 를 활용한 init 여부
    token: null,
    mall: {},
});


const actions = {
    [CAFE24_COMPLETE_INIT]: async ({commit, state}, {code, token}) => {
        try {
            if (state.token !== token) {
                console.log(`### token invalid ${state.token} : ${token}`);
                window.location.href = ROUTE_CAFE24_ERROR;
                return;
            }

            const redirectUrl = `${window.location.origin}/cafe24`;
            const {data} = await PrintingDiyRepository.postCafe24Init(state.mall.mallId, code, redirectUrl, state.mall.shopNo);
            commit(COMPLETE_INIT);
            return data;
        } catch (e) {
            alert(e.response?.data?.message || '알 수 없는 에러가 발생했습니다.');
            window.location.href = ROUTE_CAFE24_ERROR;
        }
    },
    [CAFE24_SET_MALL]: async ({commit}, {token, mallId, shopNo, userId, userName, userType}) => {
        commit(SET_MALL, {token, mallId, shopNo, userId, userName, userType});
    },
};

const mutations = {
    [COMPLETE_INIT]: (state) => {
        state.token = null;
        state.isInit = true;
    },
    [SET_MALL]: (state, {token, mallId, shopNo, userId, userName, userType}) => {
        console.log('### token append ' + token);
        state.isInit = false;
        state.token = token;
        state.mall = {mallId, shopNo, userId, userName, userType};
    },
};

export default {
    state: getInitState(),
    getters: {},
    actions,
    mutations,
};